"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.z = void 0;
const zod_1 = require("zod");
const jsonArray = () => zod_1.z.preprocess((val) => (typeof val === 'string' ? JSON.parse(val) : val), zod_1.z.array(zod_1.z.string()));
// custom zod schema that will allow us to parse a string with commas into an array of strings
const commaArray = (elementType = zod_1.z.string()) => zod_1.z.preprocess((val) => (typeof val === 'string' ? val.split(',') : val), zod_1.z.array(elementType));
const parseBool = () => zod_1.z.preprocess((val) => {
    if (typeof val === 'string') {
        if (['1', 'true'].includes(val.toLowerCase()))
            return true;
        if (['0', 'false'].includes(val.toLowerCase()))
            return false;
    }
    return val;
}, zod_1.z.coerce.boolean());
exports.z = {
    ...zod_1.z,
    commaArray,
    jsonArray,
    parseBool,
};
